<script>
import { h } from 'vue';

/**
 * Renders a schema.org JSON-LD block as a server-rendered script element so that
 * non-JS AI crawlers and answer engines (GPTBot, ClaudeBot, PerplexityBot, Google)
 * can actually read the structured data.
 *
 * Previously this injected the tag via onMounted(), which only runs in the browser,
 * so the markup was completely absent from the SSR HTML that crawlers receive.
 */
export default {
  name: 'JsonLd',
  props: {
    data: {
      type: [Object, Array],
      required: true,
    },
  },
  render() {
    if (this.data == null) return null;

    // Escape the "less-than" character (U+003C) so the JSON payload can never
    // terminate the script element early, while staying valid JSON.
    const json = JSON.stringify(this.data).split('<').join('\\u003c');

    return h('script', {
      type: 'application/ld+json',
      innerHTML: json,
    });
  },
};
</script>
